<template>
  <v-menu
    :ref="eleRef"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="label"
        v-model="valueData"
        append-outer-icon="alarm"
        v-bind="attrs"
        v-on="on"
        hide-details
        readonly
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-time-picker v-if="menu" v-model="valueData" no-title scrollable @click:minute="menu=false"></v-time-picker>
  </v-menu>
</template>
<script>
export default {
  name: 'arb-time-picker-menu',
  props: {
    value: {
      type: [String, Number]
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valueData: this.value,
      menu: false
    }
  },
  watch: {
    value (val) {
      this.valueData = val
    },
    valueData (newVal) {
      this.$emit('input', newVal)
      this.$emit('change', newVal)
    }
  },
  computed: {
    eleRef () {
      return this.ref + this._uid
    }
  }
}
</script>
